// src/api/subject/subjectApi.js
import apiClient from '../index';

export const createSubject = async (subjectData) => {
    try {
        const response = await apiClient.post('/api/subject/', subjectData);
        return response.data;
    } catch (error) {
        console.error('Error creating subject:', error);
        throw error;
    }
};

export const getSubject = async (subjectId) => {
    if (!subjectId) throw new Error('Subject ID is required');

    try {
        const response = await apiClient.get(`/api/subject/${subjectId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching subject with ID ${subjectId}:`, error);
        throw error;
    }
};

export const updateSubject = async ({ subjectId, data }) => {
    if (!subjectId) throw new Error('Subject ID is required');

    try {
        const response = await apiClient.put(`/api/subject/${subjectId}`, data);
        return response.data;
    } catch (error) {
        console.error(`Error updating subject with ID ${subjectId}:`, error);
        throw error;
    }
};

export const deleteSubject = async (subjectId) => {
    if (!subjectId) throw new Error('Subject ID is required');

    try {
        const response = await apiClient.delete(`/api/subject/${subjectId}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting subject with ID ${subjectId}:`, error);
        throw error;
    }
};

export const getAllSubjects = async () => {
    try {
        const response = await apiClient.get('/api/subject/');
        return response.data;
    } catch (error) {
        console.error('Error fetching all subjects:', error);
        throw error;
    }
};